import { useEffect } from 'react'

/**
 * Hook to manage body overflow (scroll lock) when a modal/overlay is open.
 * Automatically restores overflow on unmount.
 *
 * @param isOpen - Whether the overlay/modal is currently open
 */
export function useBodyOverflow(isOpen: boolean): void {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])
}
